import { MutationTree } from 'vuex';
import { DocumentsState, PersonalDocuments, SponsorDocuments } from './state';

const mutations: MutationTree<DocumentsState> = {
  SET_PERSONAL_DOCUMENTS(state, personalDocuments: PersonalDocuments) {
    state.personalDocuments = personalDocuments;
  },
  SET_SPONSOR_DOCUMENTS(state, sponsorDocuments: SponsorDocuments) {
    state.sponsorDocuments = sponsorDocuments;
  },
};

export default mutations;
